var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.969 10.673h4.423v4.423c0 .328.273.608.608.608a.62.62 0 00.615-.608v-4.423h4.416a.614.614 0 00.609-.608.62.62 0 00-.609-.616h-4.416V5.033A.62.62 0 0010 4.425a.614.614 0 00-.608.608V9.45H4.969a.62.62 0 00-.609.616c0 .334.28.608.609.608z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "static/media/plus.5856ae3c.svg";
export { SvgPlus as ReactComponent };